import React from "react";

const Checkbox = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            fill={fill}
            d="M3.778 2h28.444C33.204 2 34 2.796 34 3.778v28.444c0 .982-.796 1.778-1.778 1.778H3.778A1.778 1.778 0 0 1 2 32.222V3.778C2 2.796 2.796 2 3.778 2Zm1.778 3.556v24.888h24.888V5.556H5.556Zm10.67 19.555L8.685 17.57l2.515-2.515 5.028 5.029 10.057-10.057 2.514 2.514-12.571 12.571Z"
        />
    </svg>
);

export default Checkbox;